import Axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import  JWTDecode from "jwt-decode"
import { base_url } from "../utils/env";

export const service = Axios.create({ baseURL: base_url })

//export const service = Axios.create({ baseURL: "http://localhost:7008" })
service.interceptors.request.use( (config: AxiosRequestConfig) =>{
	const token = localStorage.getItem("token") as string
	if (token && token !== ""){
		const jwt_exp = localStorage.getItem("jwt_exp") as string;
		if ((new Date()).getTime() > parseInt(jwt_exp)) {
			localStorage.removeItem("userName");
			localStorage.removeItem("token");
			localStorage.removeItem("currentCompanySelected")
			window.location.replace(window.location.origin + '/?masterID=' + localStorage.getItem("masterID"));
		}
		config.headers = { Auth: `Bearer ${token}` }
	}
	return config
});
service.interceptors.response.use((response: AxiosResponse<any>) => response, (error: any) =>{
	switch (error.response.status){
		case 404: return Promise.reject('There was an error on the request')
		case 500: return Promise.reject(error.response.data.ExceptionMessage)
		default: return Promise.reject(error)
	}
})
export function configureService(defaults: AxiosRequestConfig): void{
	service.defaults = defaults
}
export function getRequestParams (){
	const token = localStorage.getItem('token') as string;
	return JWTDecode(token)
}

